module.exports = __webpack_public_path__ + "media/images/favicon-ff8602add15b2b5d03174a33e1425f7f.ico";